import {Component} from 'react'
import PropTypes from 'prop-types'
import {Map} from 'immutable'

import Closer from '../../../../../../shared_components/core/closer/Closer'
import Modals from '../../../../../../shared_components/core/modals/Modals'
import VersionForm from './VersionForm'

import {apiV2MetaDataCall} from '../../../../../../lib/apiV2Tools'

export default class UpdateVersionFormController extends Component {
  constructor() {
    super()

    this.state = {processing: false, showModal: false}

    this.closer = this.closer.bind(this)
    this.submitVersion = this.submitVersion.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
  }

  closer() { return <Closer closer={this.toggleModal} /> }

  toggleModal() { this.setState({showModal: !this.state.showModal}) }

  submitVersion(versionAttributes) {
    this.setState({processing: true})

    const resource = {
      type: 'versions',
      id: this.props.version.get('id'),
      attributes: versionAttributes
    }

    return apiV2MetaDataCall({
      apiCall: this.props.updateResource,
      resource
    }).then(() => {
      this.setState({processing: false})
      this.toggleModal()
    })
  }

  render() {
    return (
      <div className='update-version-form'>
        <a onClick={this.toggleModal}>Update version</a>
        <Modals.PopUpModal showModal={this.state.showModal} closerComponent={this.closer}>
          <VersionForm
            {...this.props}
            processing={this.state.processing}
            submitVersion={this.submitVersion}
            showModal={this.state.showModal}
          />
        </Modals.PopUpModal>
      </div>
    )
  }
}

UpdateVersionFormController.propTypes = {
  updateResource: PropTypes.func,
  version: PropTypes.instanceOf(Map)
}
